import React from 'react';
import styled from 'styled-components';
import { P } from '@components/shared/Typography';
import Colors from '@components/shared/Colors';
import IconMinus from '@images/account/icon-lg-minus.svg';
import IconPlus from '@images/account/icon-lg-plus.svg';

interface Props {
  count: number;
  add: () => void;
  remove: () => void;
  disableAdd: boolean;
  disableRemove: boolean;
  type: string;
}

export default function BoxCounter({ count, add, remove, disableAdd, disableRemove, type }: Props) {
  return (
    <ButtonWrapper>
      <Button className={`${type}-remove-btn`} name={`Add ${type}`} disabled={disableRemove} onClick={remove}>
        <IconMinusStyled />
      </Button>
      <PStyled className="box-item-count" data-variant={type}>
        {count}
      </PStyled>
      <Button className={`${type}-add-btn`} name={`Remove ${type}`} disabled={disableAdd} onClick={add}>
        <IconPlusStyled />
      </Button>
    </ButtonWrapper>
  );
}

const PStyled = styled(P)`
  && {
    font-family: 'Domaine';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    text-align: center;
    color: ${Colors.navyBlue};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90px;
`;

const Button = styled.button`
  background: none;
  outline: inherit;
  width: 24px;
  height: 24px;
  border: none;
  display: flex;
  background: ${Colors.paleGold};
  color: ${Colors.darkGreen};
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};

  &:hover {
    ${({ disabled }) => {
      if (!disabled) {
        return `
          background-color: ${Colors.navyBlue};
          cursor: pointer;

          svg path, svg rect {
            fill: ${Colors.paleGold};
          }
        `;
      }
    }}
  }
`;

const IconMinusStyled = styled(IconMinus)`
  width: 10px;
  height: 10px;
  path {
    fill: ${Colors.navyBlue};
  }
`;

const IconPlusStyled = styled(IconPlus)`
  width: 10px;
  height: 10px;
  path {
    fill: ${Colors.navyBlue};
  }
`;
